export const logo = require('./logo.png');
export const avatar = require('./avatar.png');
export const bannerImage = require('./banner.jpg');
export const bannerImageMobile = require('./banner.jpg');
export const homeBanner = require('./banner.jpg');
export const loginBackground = require('./login.jpg');
export const copernicus = require('./copernicus.png');
